import { useOveragesShouldWarnBannerChecks } from 'assets/js/pages/account-settings/account-about/givebutter-plus/usePlanOverageUsageData';
import { useResetOverageWarningStoresWhenResolved } from 'assets/js/pages/account-settings/account-about/givebutter-plus/useResetOverageWarningStoresWhenResolved';
import * as ContactsOverageBanners from 'components/pages/contacts/components/ContactsOverageBanners';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const OveragesWarning = () => {
    useResetOverageWarningStoresWhenResolved();
    const { validGivebutterPlusPlan } = useCurrentAccount();
    const { shouldPromptToManagePlans } = useOveragesShouldWarnBannerChecks();

    if (!validGivebutterPlusPlan) {
        return null;
    }

    if (shouldPromptToManagePlans) {
        return <ContactsOverageBanners.RecommendedPlan />;
    }

    return (
        <>
            <ContactsOverageBanners.Warn80 />
            <ContactsOverageBanners.Warn90 />
            <ContactsOverageBanners.Warn100 />
        </>
    );
};

export { OveragesWarning };
